export default __webpack_public_path__ + "static/media/Creative_Requests_Templates.b5ed29cb.webp";